import { StarsAutocomplete, StarsButton, Translation } from '@ps/web-shared-components';
import { required } from '@ps/web-shared-validators';
import React, { useState } from 'react';
import { useFormState } from 'react-final-form';
import { useDispatch, useSelector } from 'react-redux';

import { styles as sharedStyles } from '@swf/account';
import type { Dispatch } from '@swf/core/store';
import { select } from '@swf/core/store';
import { buildFormErrors } from '@swf/core/utils/forms';
import occupations from '@swf/generated/occupations.json';

import {
  TXTCLI_Confirm,
  TXTWCL_Occupation,
  TXTWCL_Please_enter_your_occupationX,
  TXTWCL_Please_select_your_occupation__ELL
} from './ForcedOccupation.messages.json';

interface Props {
  onContinue?: () => void;
}

const ForcedOccupation: React.FC<Props> = ({ onContinue }) => {
  const isEmbedded = useSelector(select.device.isEmbedded);
  const occupationInfo = useSelector(select.account.getOccupationInfo);
  const {
    values: { occupation },
    pristine
  } = useFormState();
  const {
    account: { updateAccount },
    modal
  } = useDispatch<Dispatch>();
  const [loading, setLoading] = useState(false);

  const submitHandler = async () => {
    setLoading(true);
    const response = await updateAccount({
      occupationInfo: { ...occupationInfo, occupation }
    });
    setLoading(false);
    const errors = buildFormErrors(response);
    if (!errors && onContinue) {
      return onContinue();
    }
    if (!errors) {
      isEmbedded ? window.close() : modal.close('/notifications/forced-occupation');
    }
    return errors;
  };

  return (
    <div className={sharedStyles.formWithDropdown}>
      <Translation tagName="p" {...TXTWCL_Please_enter_your_occupationX} />
      <StarsAutocomplete
        hideLabel
        dataTestId="autocomplete-forcedoccupation"
        id="occupation"
        options={occupations}
        matchFrom="start"
        limit={100}
        label={TXTWCL_Occupation}
        maxLength={50}
        validators={[required(TXTWCL_Please_select_your_occupation__ELL)]}
      />
      <StarsButton
        block
        disabled={pristine}
        loading={loading}
        className={sharedStyles.submit}
        translation={TXTCLI_Confirm}
        onClick={submitHandler}
      />
    </div>
  );
};

export default ForcedOccupation;
